import React from 'react';

function AiPlusIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="AI Plus Icon"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}>
      <g clipPath="url(#iim-col-clip)">
        <path
          d="M9.86425 10.6068C9.86425 9.06733 8.81929 7.16458 7.37037 5.01306C6.7088 4.02905 4.99018 1.32333 4.99018 1.32333C4.99018 1.32333 3.2643 3.96748 2.53621 5.01306C1.3449 6.72246 0 8.89245 0 10.6068C0 12.6253 0.914342 14.9899 2.8809 15.8704C3.35138 16.0712 2.79745 15.6931 2.34028 14.427C1.4465 11.9529 3.39371 11.4307 3.57996 8.80501C3.61383 8.47249 3.60778 8.04761 3.62108 7.74341C3.62713 7.55129 3.6743 7.44907 3.8279 7.63996C4.80392 8.80255 5.38083 10.241 5.30584 11.7152C5.27682 12.2903 5.75697 12.6216 6.25526 12.1671C6.75355 11.7127 6.62898 11.1979 6.67252 10.8124C6.71606 10.677 6.84305 10.8395 6.89989 10.9085C7.75013 11.9134 8.11297 14.1586 6.88901 15.2719C6.29275 15.8138 6.24437 16.1069 6.57818 15.964C8.68987 15.0625 9.86667 12.842 9.86667 10.608L9.86425 10.6068Z"
          fill="url(#iim-col-gradient-0)"
        />
        <path
          d="M12.8016 0L11.8744 2.27222L9.59998 3.20081L11.8728 4.12778L12.8 6.4L13.7272 4.12778L16 3.20081L13.7272 2.27383L12.8016 0Z"
          fill="url(#iim-col-gradient-1)"
        />
      </g>
      <defs>
        <linearGradient
          id="iim-col-gradient-0"
          x1="-0.45679"
          y1="-0.0526039"
          x2="13.6853"
          y2="0.385068"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.263745" stopColor="#3D1A9E" />
          <stop offset="0.879808" stopColor="#1835D9" />
        </linearGradient>
        <linearGradient
          id="iim-col-gradient-1"
          x1="9.30368"
          y1="-0.6"
          x2="18.4663"
          y2="-0.178195"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.263745" stopColor="#3D1A9E" />
          <stop offset="0.879808" stopColor="#1835D9" />
        </linearGradient>
        <clipPath id="iim-col-clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AiPlusIcon;
